import { isNil } from 'lodash';
import React, { useContext } from 'react';

export type Action<K, V = void> = V extends void ? { type: K } : { type: K } & V;

export function createCtx<T extends object | null>(defaultValue?: T) {
  const ctx = React.createContext<T | undefined>(defaultValue);

  const useCtx = (): T => {
    const ctxValue = useContext(ctx);
    if (isNil(ctxValue)) {
      throw new Error('useCtx must be inside a Provider with a value');
    }
    return ctxValue;
  };

  return [useCtx, ctx.Provider, ctx] as const;
}
